<template>
  <div class="accreditor-detail">
    <v-card flat>
      <v-card-text class="accreditor-detail__body">
        <div class="accreditor-detail__grid">
          <div class="accreditor-detail__item">
            <div class="accreditor-detail__label">Accreditor Name</div>
            <div class="accreditor-detail__value">
              {{ values.accreditorName ? values.accreditorName : "-" }}
            </div>
          </div>
          <div class="accreditor-detail__item">
            <div class="accreditor-detail__label">Accreditor's Geolocation</div>
            <div class="accreditor-detail__value">
              {{ values?.region?.name ?? "-" }}
            </div>
          </div>
          <div class="accreditor-detail__item">
            <div class="accreditor-detail__label">Accreditor's Ownership</div>
            <div class="accreditor-detail__value">
              {{ values.accredatorOwnership ? values.accredatorOwnership.name : "-" }}
            </div>
          </div>
          <div class="accreditor-detail__item">
            <div class="accreditor-detail__label">Accreditor's Director Name</div>
            <div class="accreditor-detail__value">
              {{ values.accreditorDirectorName ? values.accreditorDirectorName : "-" }}
            </div>
          </div>
          <div class="accreditor-detail__item">
            <div class="accreditor-detail__label">Accreditor's Director Email Address</div>
            <div class="accreditor-detail__value">
              {{ values.accreditorDirectorEmail ? values.accreditorDirectorEmail : "-" }}
            </div>
          </div>
          <div class="accreditor-detail__item">
            <div class="accreditor-detail__label">Accreditor's Director Phone Number</div>
            <div class="accreditor-detail__value">
              {{ values.accreditorDirectorPhone ? values.accreditorDirectorPhone : "-" }}
            </div>
          </div>
          <div class="accreditor-detail__item">
            <div class="accreditor-detail__label">Institutional Email</div>
            <div class="accreditor-detail__value">
              {{ values.institutionalEmail ? values.institutionalEmail : "-" }}
            </div>
          </div>
          <div class="accreditor-detail__item">
            <div class="accreditor-detail__label">Institutional Phone Number</div>
            <div class="accreditor-detail__value">
              {{ values.institutionalPhone ? values.institutionalPhone : "-" }}
            </div>
          </div>
          <div class="accreditor-detail__item">
            <div class="accreditor-detail__label">Accreditation Date</div>
            <div class="accreditor-detail__value">
              {{ values.accreditationDate ? values.accreditationDate : "-" }}
            </div>
          </div>
          <div class="accreditor-detail__item">
            <div class="accreditor-detail__label">Accreditation Code</div>
            <div class="accreditor-detail__value">
              {{ values.accreditationCode ? values.accreditationCode : "-" }}
            </div>
          </div>
          <div class="accreditor-detail__item">
            <div class="accreditor-detail__label">Accreditor Status</div>
            <div class="accreditor-detail__value">
              <v-chip :color="getColor(values)" dark small>
                {{ getStatusLabel(values) }}
              </v-chip>
            </div>
          </div>
        </div>
        <div class="accreditor-detail__map">
          <div class="accreditor-detail__map-header">
            <label class="accreditor-detail__label">Location on Map</label>
            <v-btn
                class="accreditor-detail__map-toggle"
                text
                small
                type="button"
                @click="toggleMapSize"
            >
              <v-icon left small>{{ mapExpanded ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon>
              {{ mapExpanded ? "Minimize map" : "Expand map" }}
            </v-btn>
          </div>
          <div class="accreditor-detail__map-shell" :class="{ 'is-expanded': mapExpanded }">
            <div ref="accreditorDetailMap" class="accreditor-detail__map-view"></div>
          </div>
          <div class="accreditor-detail__map-hint">
            {{ hasCoordinates ? "Map shows stored latitude and longitude." : "No location stored yet." }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import "../../plugins/leaflet/leaflet.css";
import * as L from "leaflet";

const ETHIOPIA_GEOJSON = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      id: "ETH",
      properties: {
        name: "Ethiopia",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [37.90607, 14.95943],
            [38.51295, 14.50547],
            [39.0994, 14.74064],
            [39.34061, 14.53155],
            [40.02625, 14.51959],
            [40.8966, 14.11864],
            [41.1552, 13.77333],
            [41.59856, 13.45209],
            [42.00975, 12.86582],
            [42.35156, 12.54223],
            [42, 12.1],
            [41.66176, 11.6312],
            [41.73959, 11.35511],
            [41.75557, 11.05091],
            [42.31414, 11.0342],
            [42.55493, 11.10511],
            [42.776852, 10.926879],
            [42.55876, 10.57258],
            [42.92812, 10.02194],
            [43.29699, 9.54048],
            [43.67875, 9.18358],
            [46.94834, 7.99688],
            [47.78942, 8.003],
            [44.9636, 5.00162],
            [43.66087, 4.95755],
            [42.76967, 4.25259],
            [42.12861, 4.23413],
            [41.855083, 3.918912],
            [41.1718, 3.91909],
            [40.76848, 4.25702],
            [39.85494, 3.83879],
            [39.559384, 3.42206],
            [38.89251, 3.50074],
            [38.67114, 3.61607],
            [38.43697, 3.58851],
            [38.120915, 3.598605],
            [36.855093, 4.447864],
            [36.159079, 4.447864],
            [35.817448, 4.776966],
            [35.817448, 5.338232],
            [35.298007, 5.506],
            [34.70702, 6.59422],
            [34.25032, 6.82607],
            [34.0751, 7.22595],
            [33.56829, 7.71334],
            [32.95418, 7.78497],
            [33.2948, 8.35458],
            [33.8255, 8.37916],
            [33.97498, 8.68456],
            [33.96162, 9.58358],
            [34.25745, 10.63009],
            [34.73115, 10.91017],
            [34.83163, 11.31896],
            [35.26049, 12.08286],
            [35.86363, 12.57828],
            [36.27022, 13.56333],
            [36.42951, 14.42211],
            [37.59377, 14.2131],
            [37.90607, 14.95943],
          ],
        ],
      },
    },
  ],
};

export default {
  props: {
    accreditor: Object,
  },
  data() {
    return {
      values: {},
      map: null,
      mapMarker: null,
      mapExpanded: false,
      ethiopiaBounds: null,
    };
  },
  computed: {
    hasCoordinates() {
      const lat = Number(this.values?.latitude);
      const lng = Number(this.values?.longtiude);
      return Number.isFinite(lat) && Number.isFinite(lng);
    },
  },
  watch: {
    accreditor: {
      immediate: true,
      handler(value) {
        this.values = value || {};
        if (this.map) {
          this.setMapMarkerFromValues();
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },
  methods: {
    getStatusLabel(item) {
      if (item?.statusLabel) {
        return item.statusLabel;
      }
      return item?.isActive === false ? "Not Active" : "Active";
    },
    getColor(item) {
      const status = this.getStatusLabel(item);
      if (status === "Expired") return "orange darken-2";
      if (status === "Not Active") return "red";
      return "green";
    },
    initMap() {
      if (!this.$refs.accreditorDetailMap) return;
      if (this.map) {
        this.map.remove();
        this.map = null;
      }
      const ethiopiaLayer = L.geoJSON(ETHIOPIA_GEOJSON, {interactive: false});
      const ethiopiaBounds = ethiopiaLayer.getBounds();
      this.ethiopiaBounds = ethiopiaBounds;
      const map = L.map(this.$refs.accreditorDetailMap, {
        attributionControl: false,
        maxBounds: ethiopiaBounds,
        maxBoundsViscosity: 1.0,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {}).addTo(map);
      ethiopiaLayer.addTo(map);

      const minZoom = map.getBoundsZoom(ethiopiaBounds);
      map.setMinZoom(minZoom);
      map.fitBounds(ethiopiaBounds, {padding: [12, 12]});
      this.map = map;

      this.setMapMarkerFromValues();
    },
    toggleMapSize() {
      this.mapExpanded = !this.mapExpanded;
      this.$nextTick(() => {
        if (this.map) {
          this.map.invalidateSize();
        }
      });
    },
    setMapMarkerFromValues() {
      if (!this.map) return;
      const lat = Number(this.values?.latitude);
      const lng = Number(this.values?.longtiude);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        if (this.mapMarker) {
          this.map.removeLayer(this.mapMarker);
          this.mapMarker = null;
        }
        return;
      }
      this.setMapMarker(lat, lng);
    },
    setMapMarker(lat, lng) {
      if (!this.map) return;
      const latLng = L.latLng(lat, lng);
      if (!this.mapMarker) {
        this.mapMarker = L.circleMarker(latLng, {
          radius: 8,
          color: "#1976d2",
          fillColor: "#1976d2",
          fillOpacity: 0.75,
        }).addTo(this.map);
      } else {
        this.mapMarker.setLatLng(latLng);
      }
      this.map.panTo(latLng);
    },
  },
};
</script>

<style scoped>
.accreditor-detail__body {
  padding: 16px 20px 24px;
}

.accreditor-detail__grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 12px;
}

@media (min-width: 768px) {
  .accreditor-detail__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.accreditor-detail__item {
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  min-height: 64px;
}

.accreditor-detail__label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 6px;
  display: block;
}

.accreditor-detail__value {
  font-size: 13px;
  color: #0f172a;
}

.accreditor-detail__map {
  margin-top: 16px;
}

.accreditor-detail__map-shell {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #f8fafc;
}

.accreditor-detail__map-view {
  height: 260px;
  width: 100%;
}

.accreditor-detail__map-shell.is-expanded .accreditor-detail__map-view {
  height: 70vh;
}

.accreditor-detail__map-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.accreditor-detail__map-toggle {
  color: #1976d2 !important;
  text-transform: none;
  font-weight: 600;
}

.accreditor-detail__map-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #475569;
}
</style>
